import { useMemo } from 'react';

import { Box } from '@cast/design-system';
import { WorkloadGpuUtilizationTable } from '@cast/split-me/features/cluster/cost-report';
import { FailedToLoad } from '@cast/shared-messages-ui';

import { inventoryWorkloadTableKeys, tableCacheKeys } from '../../consts';

import { useGpuMetricsFlag } from '@cast/split-me/hooks';

import { DateRangeUnsupportedBanner } from '../dashboard/_components/DateRangeUnsupportedBanner';
import { useInventoryWorkloadsTimeRangeSelection } from '../../_hooks/useInventoryWorkloadsTimeRangeSelection';
import { useInventoryWorkloadGpuData } from './_hooks';

export const InventoryWorkloadListGpu = () => {
  const { data, isLoading, error, isRangeSupported } =
    useInventoryWorkloadGpuData();
  const { timeZone } = useInventoryWorkloadsTimeRangeSelection();
  const showGpuMetrics = useGpuMetricsFlag();

  const intervals = useMemo(() => data.intervals, [data.intervals]);

  if (!isRangeSupported) {
    return (
      <Box mt={24}>
        <DateRangeUnsupportedBanner testId="inventory-workload-gpu-unsupported-range" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={24}>
        <FailedToLoad title="Failed to load workload GPU utilization details" />
      </Box>
    );
  }

  return (
    <WorkloadGpuUtilizationTable
      intervals={intervals}
      isLoading={isLoading}
      timezone={timeZone}
      cacheKey={tableCacheKeys.INVENTORY_WORKLOAD.GPU_UTILIZATION}
      urlKey={inventoryWorkloadTableKeys.GPU_UTILIZATION}
      testId="inventory-workload-gpu-table"
      showGpuMetrics={showGpuMetrics}
    />
  );
};
